export default __webpack_public_path__ + "static/media/banner1.491cba9c.png";